import { useMemo } from 'react';

import { useSelector } from '../../store/use-appstate-selector';

/**
 * What the member's own contact is called on a filter chip.
 *
 * "Meine" and "Von mir bestellt" narrow a list to the signed-in contact by its
 * id. Reached from the navigation, no filter field has learnt the name, so the
 * chip read "Mitarbeiter 22.139" (R-155); the name is known here already.
 */
type FilterNames = Record<string, { value: string; label: string }[]>;

export const useOwnContactFilterNames = (): FilterNames => {
    const user = useSelector(state => state.user);

    return useMemo<FilterNames>(() => {
        const names: FilterNames = {};

        if (user?.contact) {
            names['customerContactId'] = [{ value: String(user.contact.id), label: user.fullName }];
        }

        return names;
    }, [user]);
};
